import { makeStyles } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import {
  FacebookIcon,
  InstagramIcon,
  LogoIcon,
  PhoneIcon,
  TwitterIcon,
} from "v2/icons";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    margin: 10,
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  left: {
    flex: 1,
    display: "flex",
    justifyContent: "space-between",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  right: {
    flex: 1,
    display: "flex",
    justifyContent: "end",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  trustauto: {
    fontWeight: 900,
    marginLeft: 8,
  },
  nav: {
    flex: 1,
    display: "flex",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
      background: "rgba(196, 196, 196, 0.81)",
    },
  },
  ul: {
    listStyleType: "none",
    fontWeight: 700,
    "&>li": {
      float: "left",
      display: "inline",
      "&>a": {
        display: "block",
        color: "#363636",
        textAlign: "center",
        padding: 16,
        marginLeft: 5,
        marginRight: 5,
        textDecoration: "none",
        position: "relative",
        "&:hover": {
          color: "#DDBB78",
          textDecoration: "underline",
        },
      },
    },
  },
  logo: {
    flex: 1,
    display: "flex",
    padding: 16,
    cursor: "pointer",
  },
  contact: {
    marginLeft: "auto",
    display: "flex",
    fontWeight: 500,
    padding: 16,
    fontSize: 14,
  },
  phone: {
    marginLeft: 10,
    paddingTop: 4,
    paddingRight: 16,
    paddingBottom: 4,
  },
  btn: {
    textDecoration: "none",
    width: 160,
    color: "#363636",
    textAlign: "center",
    background: "#DDBB78",
    paddingTop: 4,
    paddingBottom: 4,
    cursor: "pointer",
    maxHeight: 40,
  },
  social_footer_ul: {
    display: "table",
    margin: "15px auto 0 auto",
    marginBottom: "auto",
    marginTop: "auto",
    "@media only screen and (max-width: 1280px)": {
      display: "flex",
      marginRight: "auto",
      marginLeft: "auto",
      justifyContent: "center",
    },
    listStyleType: "none",
    "&>li": {
      paddingLeft: 20,
      paddingTop: 10,
      "@media only screen and (max-width: 1280px)": {
        display: "flex",
        marginRight: "auto",
        marginLeft: "auto",
        justifyContent: "center",
      },
      float: "left",
      "&>i": { width: 20, height: 20, textAlign: "center" },
    },
  },
}));

export function Header(props) {
  const styles = useStyles();
  return (
    <header className={styles.root}>
      <div className={styles.left}>
        <div className={styles.logo}>
          <div>
            <LogoIcon />
          </div>
          <div className={styles.trustauto}>
            <Link
              style={{
                color: "#3c4858",
              }}
              to="/"
            >
              TrustAuto
            </Link>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.contact}>
          <div>
            <PhoneIcon />
          </div>
          <div className={styles.phone}>+221 77 782 66 04</div>
          <a className={styles.btn} href="tel:+221777826604">
            Appeler
          </a>
        </div>
        <div>
          <ul className={styles.social_footer_ul}>
            <li>
              <a href="https://web.facebook.com/TRUSTAuto-Taxi-105798771155286">
                <FacebookIcon />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/trustauto_taxi">
                <TwitterIcon />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/trustauto_taxi">
                <i>
                  <InstagramIcon />
                </i>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
